var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoEcodrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        mask: url(#mask);\n      }\n\n      .st1 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#D\xE9grad\xE9_sans_nom_2);\n      }\n\n      .st3, .st4, .st5, .st6 {\n        mix-blend-mode: multiply;\n      }\n\n      .st7 {\n        fill: url(#D\xE9grad\xE9_sans_nom_9);\n        mix-blend-mode: lighten;\n        opacity: .3;\n      }\n\n      .st8 {\n        filter: url(#luminosity-noclip2);\n      }\n\n      .st9 {\n        filter: url(#luminosity-noclip4);\n      }\n\n      .st10 {\n        fill: url(#D\xE9grad\xE9_sans_nom_91);\n        mix-blend-mode: overlay;\n        opacity: .7;\n      }\n\n      .st11 {\n        fill: url(#D\xE9grad\xE9_sans_nom_11);\n      }\n\n      .st11, .st12, .st13 {\n        fill-rule: evenodd;\n      }\n\n      .st14 {\n        fill: url(#D\xE9grad\xE9_sans_nom_111);\n      }\n\n      .st15 {\n        fill: url(#D\xE9grad\xE9_sans_nom_101);\n      }\n\n      .st16 {\n        isolation: isolate;\n      }\n\n      .st17 {\n        mask: url(#mask-2);\n      }\n\n      .st18 {\n        mask: url(#mask-3);\n      }\n\n      .st19 {\n        mask: url(#mask-4);\n      }\n\n      .st20 {\n        mask: url(#mask-5);\n      }\n\n      .st21 {\n        mask: url(#mask-1);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient);\n      }\n\n      .st22 {\n        fill: url(#D\xE9grad\xE9_sans_nom_10);\n      }\n\n      .st4 {\n        fill: url(#D\xE9grad\xE9_sans_nom_21);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n        opacity: .6;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_11",
    "data-name": "D\\xE9grad\\xE9 sans nom 11",
    x1: 500.5,
    y1: 576,
    x2: 500.5,
    y2: 825.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a7f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e6338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 641.4,
    y1: 682.7,
    x2: 346.6,
    y2: 759.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b5d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16191d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 601.2,
    y1: 527.8,
    x2: 306.4,
    y2: 604.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f6162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16191d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 709.7,
    y1: 450.2,
    x2: 561.9,
    y2: 183.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ba849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_111",
    "data-name": "D\\xE9grad\\xE9 sans nom 11",
    x1: 557.1,
    y1: 132.8,
    x2: 199.3,
    y2: 508.2,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_11"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 247.7,
    y: 155.5,
    width: 270.2,
    height: 380.6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip1",
    x: 247.7,
    y: -8692,
    width: 270.2,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 247.7,
    y: -8692,
    width: 270.2,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    "data-name": "D\\xE9grad\\xE9 sans nom 2",
    x1: 628.5,
    y1: 198.9,
    x2: 320.6,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 247.7,
    y: 155.5,
    width: 270.2,
    height: 380.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302,470.9l3-11.1,68.9,18.2c-16.6-28.7-22.8-62-17.6-95.3,6.1-38.4,26.7-72.1,58.2-95,14.8-10.8,31.2-18.5,48.4-23,12.7-12.8,44.9-45.2,54.9-55.3-9.6-9.8-39.8-40.1-53.4-53.8-40.3,5.7-78.9,21.2-112.8,45.8-54.5,39.6-90.3,98.1-100.9,164.7-9.5,59.6,2.4,119.2,33.4,170.1l17.7-65.2Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    x1: 628.5,
    y1: 198.9,
    x2: 320.6,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5c590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ba849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 566,
    y1: 207.7,
    x2: 835.8,
    y2: 624.1,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip2",
    x: 494.8,
    y: 153.1,
    width: 257.5,
    height: 365.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip3",
    x: 494.8,
    y: -8692,
    width: 257.5,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 494.8,
    y: -8692,
    width: 257.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_21",
    "data-name": "D\\xE9grad\\xE9 sans nom 2",
    x1: 533.7,
    y1: 370.1,
    x2: 744.9,
    y2: 255.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 494.8,
    y: 153.1,
    width: 257.5,
    height: 365.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550.6,209.3l-50.2,50.6c7.5,0,15,.6,22.5,1.8,38.4,6.1,72.1,26.8,94.9,58.2,18.7,25.8,27.8,55.7,27.8,85.3s-1.8,25.7-5.1,38.1c4.7,17.2,16.8,61.8,20.6,75.6,13.2-3.5,54.2-14.3,73-19.3,31.2-77.9,23-169.7-29.8-242.5h0c-39.7-54.6-98.1-90.4-164.7-100.9-14.9-2.4-29.9-3.3-44.7-3l55.8,56.2Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_91",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    x1: 533.7,
    y1: 370.1,
    x2: 744.9,
    y2: 255.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_9"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip4",
    x: 247.7,
    y: 248.6,
    width: 166.8,
    height: 287.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip5",
    x: 247.7,
    y: -8692,
    width: 166.8,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 247.7,
    y: -8692,
    width: 166.8,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 331.1,
    y1: 625.4,
    x2: 331.1,
    y2: 258.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 247.7,
    y: 248.6,
    width: 166.8,
    height: 287.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.3,248.6c-26.8,33.7-44.5,73.8-51.4,117.4-9.5,59.6,2.4,119.2,33.4,170.1l17.7-65.2,3-11.1,68.9,18.2c-16.6-28.7-22.8-62-17.6-95.3,6.1-38.4,26.7-72.1,58.2-95"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 331.1,
    y1: 625.4,
    x2: 331.1,
    y2: 258.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d697f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#587e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#749558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#84a34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ba849"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M551.3,840.6c0,3.5-21.9,6.2-48.9,6.2s-48.9-2.8-48.9-6.2,21.9-6.2,48.9-6.2,48.9,2.8,48.9,6.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M641,676.2l-107,107.1c-18.4,18.4-48.5,18.4-66.9,0l-107-107.1c42.2,21.4,89.9,33.5,140.5,33.5s98.3-12.1,140.5-33.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M641,676.2l-107,107.1c-18.4,18.4-48.5,18.4-66.9,0l-107-107.1c42.2,21.4,89.9,33.5,140.5,33.5s98.3-12.1,140.5-33.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.7,547.2l-18.7-68.8c-9.9,17.1-23.4,32.5-40.4,44.8-31.5,22.9-69.9,32.1-108.3,26-31-4.9-58.9-19.4-80.6-41.2-17.4-4.6-61.6-16.3-75.4-19.9-3.6,13.2-14.8,54.3-19.9,73,39.4,50.4,95.5,83.6,159.1,93.6,66.6,10.6,133.2-5.4,187.8-45.1,31.1-22.6,55.4-50.9,72.7-82.5l-76.4,20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M550.6,209.3l-50.2,50.6c7.5,0,15,.6,22.5,1.8,38.4,6.1,72.1,26.8,94.9,58.2,18.7,25.8,27.8,55.7,27.8,85.3s-1.8,25.7-5.1,38.1c4.7,17.2,16.8,61.8,20.6,75.6,13.2-3.5,54.2-14.3,73-19.3,31.2-77.9,23-169.7-29.8-242.5h0c-39.7-54.6-98.1-90.4-164.7-100.9-14.9-2.4-29.9-3.3-44.7-3l55.8,56.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M302,470.9l3-11.1,68.9,18.2c-16.6-28.7-22.8-62-17.6-95.3,6.1-38.4,26.7-72.1,58.2-95,14.8-10.8,31.2-18.5,48.4-23,12.7-12.8,44.9-45.2,54.9-55.3-9.6-9.8-39.8-40.1-53.4-53.8-40.3,5.7-78.9,21.2-112.8,45.8-54.5,39.6-90.3,98.1-100.9,164.7-9.5,59.6,2.4,119.2,33.4,170.1l17.7-65.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M302,470.9l3-11.1,68.9,18.2c-16.6-28.7-22.8-62-17.6-95.3,6.1-38.4,26.7-72.1,58.2-95,14.8-10.8,31.2-18.5,48.4-23,12.7-12.8,44.9-45.2,54.9-55.3-9.6-9.8-39.8-40.1-53.4-53.8-40.3,5.7-78.9,21.2-112.8,45.8-54.5,39.6-90.3,98.1-100.9,164.7-9.5,59.6,2.4,119.2,33.4,170.1l17.7-65.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M550.6,209.3l-50.2,50.6c7.5,0,15,.6,22.5,1.8,38.4,6.1,72.1,26.8,94.9,58.2,18.7,25.8,27.8,55.7,27.8,85.3s-1.8,25.7-5.1,38.1c4.7,17.2,16.8,61.8,20.6,75.6,13.2-3.5,54.2-14.3,73-19.3,31.2-77.9,23-169.7-29.8-242.5h0c-39.7-54.6-98.1-90.4-164.7-100.9-14.9-2.4-29.9-3.3-44.7-3l55.8,56.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M550.6,209.3l-50.2,50.6c7.5,0,15,.6,22.5,1.8,38.4,6.1,72.1,26.8,94.9,58.2,18.7,25.8,27.8,55.7,27.8,85.3s-1.8,25.7-5.1,38.1c4.7,17.2,16.8,61.8,20.6,75.6,13.2-3.5,54.2-14.3,73-19.3,31.2-77.9,23-169.7-29.8-242.5h0c-39.7-54.6-98.1-90.4-164.7-100.9-14.9-2.4-29.9-3.3-44.7-3l55.8,56.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.3,248.6c-26.8,33.7-44.5,73.8-51.4,117.4-9.5,59.6,2.4,119.2,33.4,170.1l17.7-65.2,3-11.1,68.9,18.2c-16.6-28.7-22.8-62-17.6-95.3,6.1-38.4,26.7-72.1,58.2-95"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEcodrop);
export default __webpack_public_path__ + "static/media/picto-ecodrop.0871cc684b7da12bd93a1566078ba9ad.svg";
export { ForwardRef as ReactComponent };